var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1553 3.96967C12.4482 4.26256 12.4482 4.73744 12.1553 5.03033L8.18566 9L12.1553 12.9697C12.4482 13.2626 12.4482 13.7374 12.1553 14.0303C11.8624 14.3232 11.3876 14.3232 11.0947 14.0303L6.59467 9.53033C6.30178 9.23744 6.30178 8.76256 6.59467 8.46967L11.0947 3.96967C11.3876 3.67678 11.8624 3.67678 12.1553 3.96967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.c1cdc017571217c4856b24fe7c53f506.svg";
export { ForwardRef as ReactComponent };